import {
  AmplifyPost,
  AmplifyPatch,
} from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { DesignRequestResponse } from "../../amplify/backend/function/OfferExpSiteModel/ts/public/types";
import { logger } from "providers/logger";

const siteModelRequestDesignUpdate = async (
  jwt: string,
  prospectId: string,
  notesToDesigner: string,
  priority: string,
  queue: string,
  status: string,
  image?: Blob,
  contentType?: string
): Promise<DesignRequestResponse> => {
  const formData = new FormData();
  formData.append("notesToDesigner", notesToDesigner);
  formData.append("priority", priority);
  formData.append("queue", queue);
  formData.append("status", status);
  formData.append("documentBlob", image || "");
  formData.append("contentType", contentType || "");
  return await AmplifyPost<DesignRequestResponse>(
    "Request Design Update",
    "OfferExpApi",
    `/prospect/${prospectId}/designRequest/update`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": `multipart/form-data`,
      },
      body: formData,
    },
    logger
  );
};

const siteModelRequestDesignUpdatePriority = async (
  hybridToken: string,
  prospectId: string,
  designRequestId: string,
  priority: string
): Promise<DesignRequestResponse> => {
  return await AmplifyPatch<DesignRequestResponse>(
    "Request Design Update",
    "OfferExpApi",
    `/prospect/${prospectId}/designRequest/${designRequestId}/updatePriority`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
        "Content-Type": `application/json`,
      },
      body: {
        priority,
      },
    },
    logger
  );
};

export { siteModelRequestDesignUpdate, siteModelRequestDesignUpdatePriority };
